import * as Yup from 'yup';

import { NOTIFICATION_MESSAGES } from '../constants';

const requiredMessage = `This field is required`;

export const sampleFormValidationSchema = (isDiagnosticumUser = false) => {
  const sampleIdSchema = Yup.string()
    .trim()
    .required(requiredMessage)
    .nullable();

  const fields: any = {
    sample_id: isDiagnosticumUser
      ? sampleIdSchema.matches(
          /^\d{9}$/,
          NOTIFICATION_MESSAGES.DIAGNOSTICUM_SAMPLE_ID_INVALID,
        )
      : sampleIdSchema,
    zygosity: Yup.string().trim().required(requiredMessage).nullable(),
    // segregation ist beim Anlegen eines neuen Samples Pflicht (analog zu Zygosity)
    segregation: Yup.string().trim().required(requiredMessage).nullable(),
    comment: Yup.mixed().nullable(), // Accepts EditorState or null
  };

  return Yup.object().shape(fields);
};
